var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"typewriter"},[_vm._t("default"),_c('span',{staticClass:"typewriter-msg",class:{"typewriter-selected":_vm.isFullErasing}},[_vm._v(_vm._s(_vm.typing))]),(_vm.cursor)?_c('span',{staticClass:"typewriter-cursor"},[_vm._v(_vm._s(_vm.cursorSymbol))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }